import { render, staticRenderFns } from "./SocialBar.vue?vue&type=template&id=7368082a&scoped=true"
import script from "./SocialBar.vue?vue&type=script&lang=js"
export * from "./SocialBar.vue?vue&type=script&lang=js"
import style0 from "./SocialBar.vue?vue&type=style&index=0&id=7368082a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7368082a",
  null
  
)

export default component.exports